"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/toConsumableArray.js"));

var _mockjs = _interopRequireDefault(require("mockjs"));

var _index = require("../../src/utils/index.js");

var _routes = require("./routes.js");

var routes = (0, _index.deepClone)([].concat((0, _toConsumableArray2.default)(_routes.constantRoutes), (0, _toConsumableArray2.default)(_routes.asyncRoutes)));
var roles = [{
  key: 'admin',
  name: 'admin',
  description: 'Super Administrator. Have access to view all pages.',
  routes: routes
}, {
  key: 'editor',
  name: 'editor',
  description: 'Normal Editor. Can see all pages except permission page',
  routes: routes.filter(function (i) {
    return i.path !== '/permission';
  }) // just a mock

}, {
  key: 'visitor',
  name: 'visitor',
  description: 'Just a visitor. Can only see the home page and the document page',
  routes: [{
    path: '',
    redirect: 'dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      meta: {
        title: 'dashboard',
        icon: 'dashboard'
      }
    }]
  }]
}];
var _default = [// mock get all routes form server
{
  url: '/routes',
  type: 'get',
  response: function response(_) {
    return {
      code: 200,
      data: routes
    };
  }
}, // mock get all roles form server
{
  url: '/roles',
  type: 'get',
  response: function response(_) {
    return {
      code: 200,
      data: roles
    };
  }
}, // add role
{
  url: '/role',
  type: 'post',
  response: {
    code: 200,
    data: {
      key: _mockjs.default.mock('@integer(300, 5000)')
    }
  }
}, // update role
{
  url: '/role/[A-Za-z0-9]',
  type: 'put',
  response: {
    code: 200,
    data: {
      status: 'success'
    }
  }
}, // delete role
{
  url: '/role/[A-Za-z0-9]',
  type: 'delete',
  response: {
    code: 200,
    data: {
      status: 'success'
    }
  }
}];
exports.default = _default;